/* istanbul ignore file */

import { Carriers } from '../constants/carriers';
import { CarrierConfig } from './carrierConfig';

export class CarrierSeniorLife extends CarrierConfig {
  getCarrier(): Carriers {
    return Carriers.SENIOR_LIFE;
  }
  getCarrierDisplayName(): string {
    return 'Senior Life Insurance Company';
  }
  getLabel(): string {
    return 'SeniorLife';
  }
}
